import type { ApiPromise } from '@polkadot/api';
import type { SubmittableExtrinsic, Signer } from '@polkadot/api/types';
import type { AddressOrPair } from '@polkadot/api/types';
import type { ISubmittableResult, IKeyringPair } from '@polkadot/types/types';
import type { DispatchError } from '@polkadot/types/interfaces';

export class ExtrinsicError extends Error {
  constructor(extrinsicName: string, message: string) {
    super(`ExtrinsicFailed: ${extrinsicName}: ${message}`)
    this.name = extrinsicName
  }
}

export function waitExtrinsicFinished(khalaApi: ApiPromise, extrinsic: SubmittableExtrinsic<'promise'>, account: AddressOrPair, signer?: Signer): Promise<ISubmittableResult> {
  return new Promise(async (resolve, reject) => {
    let _acc = account
    let options = {}
    if (signer) {
      _acc = (account as IKeyringPair).address
      options = { signer }
    }
    const unsub = await extrinsic.signAndSend(_acc, options, (result) => {
      if (result.status.isInBlock) {
        // console.log(`Transaction included at blockHash ${result.status.asInBlock}`);
      } else if (result.status.isFinalized) {
        // console.log(`Transaction finalized at blockHash ${result.status.asFinalized}`);
      }

      if (result.status.isInBlock || result.status.isFinalized) {
        const failures = result.events.filter(({event}) => {
          return khalaApi.events.system?.ExtrinsicFailed?.is(event)
        })
        const errors = failures.map(
          ({
             event: {
               data: [error],
             },
           }) => {
            if ((error as DispatchError)?.isModule?.valueOf()) {
              // https://polkadot.js.org/docs/api/cookbook/tx#how-do-i-get-the-decoded-enum-for-an-extrinsicfailed-event
              const decoded = khalaApi.registry.findMetaError((error as DispatchError).asModule)
              const {docs, method, section} = decoded
              return new ExtrinsicError(`${section}.${method}`, docs.join(' '))
            } else {
              return new Error(error?.toString() ?? String.toString.call(error))
            }
          }
        )
        if (errors.length > 0) {
            reject(errors[0])
        } else {
          resolve(result)
        }
        unsub();
      }
    });
  })
}